const createDateTimeString = (
    date: Date | undefined,
    time: string,
    useLocalTime = false,
) => {
    if (!date) return undefined;
    const [hours, minutes] = time.split(":").map(Number);

    // Build a new date using individual components
    // to avoid timezone issues
    const year = date.getFullYear();
    const month = date.getMonth();
    const day = date.getDate();

    const dateTime = new Date(year, month, day, hours, minutes, 0, 0);

    if (useLocalTime) {
        // Create ISO string that represents the local time
        // Format: YYYY-MM-DDTHH:mm:ss.sssZ
        const yearLocal = dateTime.getFullYear();
        const monthLocal = String(dateTime.getMonth() + 1).padStart(2, "0");
        const dayLocal = String(dateTime.getDate()).padStart(2, "0");
        const hourLocal = String(dateTime.getHours()).padStart(2, "0");
        const minuteLocal = String(dateTime.getMinutes()).padStart(2, "0");

        return `${yearLocal}-${monthLocal}-${dayLocal}T${hourLocal}:${minuteLocal}Z`;
    }

    return dateTime.toISOString();
};

export default createDateTimeString;
